import { readStates, saveStates } from '@/constants/lifecycle';
import pagingWithFilteredResults from '@/constants/states';
import findResult, { findWithCodes, removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { datasetPermissionCategories, datasetPermissions } from '../constants';

export const datasetPerms = (can = false) => {
  const permissions = {};
  Object.values(datasetPermissions).forEach((permission) => {
    permissions[permission] = can;
  });
  return permissions;
};

export const datasetPermsFromArray = (truePermissions = []) => {
  const permissions = datasetPerms();

  truePermissions.forEach((permission) => {
    permissions[permission] = true;
  });

  return permissions;
};

export const newDatasetMember = (member, permissions) => ({
  ...member,
  permissions: { ...permissions },
  selected: false,
});

export const datasetMembers = (pageSize = 20, minFilterLength = 0, requiresFilter = false) => (
  {
    ...pagingWithFilteredResults(pageSize, minFilterLength, requiresFilter),
    original: [],
    ...readStates,
  }
);

export const sharingDatasetState = (
  category = '',
  code = '',
  name = '',
  open = false,
  permissionGroup = 'OWNER',
) => ({
  category,
  code,
  name,
  open,
  permissionGroup,
  membersToAdd: [],
  members: datasetMembers(10000),
  unassignedMembers: datasetMembers(20, 3, true),
  ...saveStates,
});

const initialState = {
  sharingDataset: { ...sharingDatasetState() },
  permissions: {
    open: {
      results: [],
    },
  },
};

export const findDatasetPermissions = ({ permissions }, { category, code }) => (
  findResult(permissions, category, code)
);

export const findAllDatasetPermissions = ({ permissions }, { items }) => {
  const codes = items.map(({ code }) => code);
  return findWithCodes(permissions, datasetPermissionCategories, codes);
};

export const findDatasetMembers = ({ sharingDataset }, { assignable }) => (
  assignable ? sharingDataset.unassignedMembers : sharingDataset.members
);

export const closeDatasetSettingsState = withDraft((draft, { category, code }) => {
  const item = findDatasetPermissions(draft, { category, code });

  if (item) {
    draft.permissions[category].results = removeItemByCode(draft.permissions[category].results, item);
  }
});

export default initialState;
